import { useEffect } from 'react'
import utils from '@/utils/utils'

export function useSessionMonitor (isAuthenticated, onExpired) {
  useEffect(() => {
    if (!isAuthenticated) return undefined

    const checkExpiration = () => {
      if (utils.isTokenExpired(utils.getToken())) {
        onExpired()
      }
    }

    checkExpiration()
    const interval = setInterval(checkExpiration, 5000)

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') checkExpiration()
    }

    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [isAuthenticated, onExpired])
}
